import { Injectable, signal } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { shouldFallbackFromSubscribly } from '../utilities/subscribly.utilities';

/**
 * Tracks whether subscrib.ly can be polled in this session.
 * Once an enriched request fails and Doddly data still loads, channel
 * management stays disabled until the page is reloaded.
 */
@Injectable({
  providedIn: 'root',
})
export class SubscriblyStatusService {
  readonly unavailable = signal(false);

  markUnavailable(): void {
    this.unavailable.set(true);
  }

  /**
   * Tries the request that polls subscrib.ly, then the Doddly-only request.
   * The basic request runs immediately when subscrib.ly is already known to be down.
   */
  withFallback<T>(
    enriched: () => Observable<T>,
    basic: () => Observable<T>,
  ): Observable<T> {
    if (this.unavailable()) {
      return basic();
    }

    return enriched().pipe(
      catchError((error: unknown) => {
        if (!shouldFallbackFromSubscribly(error)) {
          return throwError(() => error);
        }

        console.warn(
          'subscrib.ly request failed. Loading Doddly data without channel details.',
          error,
        );

        return basic().pipe(
          tap(() => this.markUnavailable()),
          catchError(() => throwError(() => error)),
        );
      }),
    );
  }
}
